import styled, { css } from 'styled-components'
import IconPrint from '../../assets/img/icon-print.svg'

export const Card = styled.div`
  ${({ theme }) => css`
    background: #fff;
    padding: 30px 30px 30px 30px;
    margin: 20px auto;
    max-width: 800px;
  `}

  .card {
    padding: 16px;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    position: relative;

    -webkit-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);

    h3 {
      font-weight: 600;
      font-size: 16px;
      margin-bottom: 8px;
      text-decoration: underline;
    }

    p {
      font-size: 14px;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    strong {
      font-size: 14px;
      font-weight: 600;
    }
  }
`

export const CardHeader = styled.div`
  background: #fff;
  position: relative;

  .print-header {
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`

export const Column = styled.div``

export const CardNumber = styled.h3`
  font-size: 18px;
  margin-bottom: 6px;
`

export const CardDescription = styled.div`
  margin-bottom: 2px;
  font-size: 15px;
  line-height: 20px;
`

export const CardContent = styled.div`
  ${({ show }) => css`
    margin-top: 20px;
    display: none;

    ${show &&
    css`
      display: block;
    `}
  `}
`

export const CardContentWrapper = styled.div``

export const Details = styled.div`
  margin: 30px 0 10px 0;
  display: flex;
  gap: 16px;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .card {
    padding: 16px;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    position: relative;

    -webkit-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);

    h3 {
      font-weight: 600;
      font-size: 16px;
      margin-bottom: 8px;
      text-decoration: underline;
    }

    p {
      font-size: 14px;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    strong {
      font-size: 14px;
      font-weight: 600;
    }
  }
`

export const DetailsItem = styled.div`
  margin-right: 40px;
  margin-bottom: 10px;
`

export const DetailsItemTitle = styled.h3`
  font-size: 15px;
  text-decoration: underline;
  margin-bottom: 10px;
`

export const DetailsList = styled.ul`
  list-style: none;
`

export const DetailsListItem = styled.li`
  margin-bottom: 10px;
  font-size: 13px;
`
export const DetailsHead = styled.div`
  display: flex;
  flex: 1;
  gap: 16px;

  /* @media (max-width: 400px) {
    width: 100%;
    flex-direction: column;
  } */
`

export const DetailsWrapper = styled.div`
  width: 50%;

  .status {
    display: flex;
  }

  /* @media (max-width: 400px) {
    width: 100%;
  } */
`
export const Tag = styled.div`
  ${({ theme, color, type }) => css`
    padding: 2px 4px;
    font-size: 13px;
    border-radius: 4px;
    color: #fff;
    font-weight: 600;
    max-height: 20px;
    margin-left: 8px;

    ${color === 'green' &&
    css`
      background-color: #27ae60;
    `}

    ${color === 'red' &&
    css`
      background-color: #fa3434;
    `}

    ${type === 'Negociação aguardando avaliação' ||
    type === 'Em Avaliação' ||
    type === 'Cotação com Pedido'
      ? css`
          color: #ffffff;
          background: ${theme.colors.alert};
        `
      : null}

    ${type === 'Negociação Avaliada' || type === 'Avaliada'
      ? css`
          color: #ffffff;
          background: ${theme.colors.success};
        `
      : null}

    ${type === 'Cancelada' &&
    css`
      color: #ffffff;
      background: ${theme.colors.error};
    `}

    ${type === 'Vencida' &&
    css`
      color: #ffffff;
      background: ${theme.colors.error};
    `}

    ${type === 'Válida' &&
    css`
      color: #ffffff;
      background: ${theme.colors.success};
    `}

    ${type === 'Cotação com Pedido' ||
    type === 'Negociação com Pedido' ||
    type === 'Convertida'
      ? css`
          color: #ffffff;
          background: #afaeae;
        `
      : null}

    ${type === 'waiting' &&
    css`
      display: none;
    `}

    ${type === null &&
    css`
      display: none;
    `}
  `}
`

export const AddressPaymentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  gap: 8px;

  /* @media (max-width: 400px) {
    width: 100%;
  } */
`

export const AddressPaymentItem = styled.div`
  .pagamento {
    display: flex;

    img {
      width: 30px;
      margin-right: 8px;
      margin-left: -4px;
    }
  }
`
